import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgShadowAnimationModule } from './shadow';
import { NgElementAnimationModule } from './element';
import { NgStylingComponentsModule } from '../../styling-components';


@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		NgElementAnimationModule,
		NgShadowAnimationModule,
		NgStylingComponentsModule
	],
	exports: [
		NgElementAnimationModule,
		NgShadowAnimationModule
	]
})
export class NgEventAnimationModule { }
